import { signInWithPopup } from 'firebase/auth';
import { auth, googleProvider } from '../firebase';

export default function Login() {
  const handleGoogleLogin = async () => {
    try {
      await signInWithPopup(auth, googleProvider);
    } catch (err) {
      alert('Login failed: ' + err.message);
    }
  };

  return (
    <div style={styles.container}>
      <style>{`
        @media (max-width: 480px) {
          .login-card { padding: 32px 24px !important; border-radius: 14px !important; }
          .login-title { font-size: 26px !important; }
        }
      `}</style>
      <div className="login-card" style={styles.card}>
        <div style={styles.logo}>✦</div>
        <h1 className="login-title" style={styles.title}>ResumeAI</h1>
        <p style={styles.subtitle}>Build your professional resume with AI in minutes</p>

        <div style={styles.features}>
          <div style={styles.feature}>⚡ AI-powered chat builder</div>
          <div style={styles.feature}>📄 Live resume preview</div>
          <div style={styles.feature}>🎯 ATS score checker</div>
          <div style={styles.feature}>⬇ PDF download</div>
        </div>

        <button style={styles.googleBtn} onClick={handleGoogleLogin}>
          <img
            src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg"
            alt="Google"
            style={{ width: '20px', height: '20px' }}
          />
          Sign in with Google
        </button>

        <p style={styles.note}>Free to use · No credit card required</p>
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh',
    background: '#0a0a0a',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: "'Inter', sans-serif",
    padding: '16px',
    boxSizing: 'border-box',
  },
  card: {
    background: '#111',
    border: '1px solid #222',
    borderRadius: '20px',
    padding: '48px 40px',
    width: '100%',
    maxWidth: '420px',
    textAlign: 'center',
  },
  logo: {
    fontSize: '40px',
    color: '#a78bfa',
    marginBottom: '12px',
  },
  title: {
    fontSize: '32px',
    fontWeight: '700',
    color: '#f0f0f0',
    margin: '0 0 8px',
  },
  subtitle: {
    fontSize: '14px',
    color: '#888',
    marginBottom: '28px',
    lineHeight: '1.5',
  },
  features: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    marginBottom: '32px',
    textAlign: 'left',
  },
  feature: {
    fontSize: '13px',
    color: '#aaa',
    background: '#1a1a1a',
    padding: '10px 14px',
    borderRadius: '8px',
    border: '1px solid #222',
  },
  googleBtn: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '12px',
    width: '100%',
    padding: '14px',
    background: '#fff',
    color: '#1a1a1a',
    border: 'none',
    borderRadius: '10px',
    fontSize: '15px',
    fontWeight: '600',
    cursor: 'pointer',
    marginBottom: '16px',
  },
  note: {
    fontSize: '12px',
    color: '#555',
  },
};